// Angular
import { Component, OnInit } from '@angular/core';
import { ApplicationPaths } from 'src/app/api-authorization/api-authorization.constants';
import { AuthorizeService } from 'src/app/api-authorization/authorize.service';
import { AppPaths } from 'src/app/app-paths.constants';
import { HomePageService } from 'src/app/home/home-page/home-page.service';
import { isGakkoDev } from 'src/app/shared/language-extensions/is-gakko-dev.language-extension';

@Component({
  selector: 'kt-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent implements OnInit {
  readonly AppPaths: AppPaths = AppPaths;
  readonly AuthPaths = ApplicationPaths;
  isAuthenticated: boolean;
  isEnrollmentActive: boolean;
  isGakkoDev: boolean = isGakkoDev;

  constructor(
    private authorizeService: AuthorizeService,
    private homeService: HomePageService
  ) { }

  ngOnInit() {
    this.initIsAuthenticated();
    this.initEnrollmentData();
  }


  private initIsAuthenticated(): void {
    this.authorizeService.isAuthenticated()
      .subscribe(isAuthenticated => this.isAuthenticated = isAuthenticated);
  }

  private initEnrollmentData(): void {
    this.homeService.getEnrollmentData()
      .subscribe(data => this.isEnrollmentActive = data?.isActive ?? false);
  }
}
